import AntdFormItem from 'antd/es/form/FormItem';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AddInputError = _ref => {
  let {
    children,
    ...childrenProps
  } = _ref;
  const {
    status
  } = AntdFormItem.useStatus();
  const isNativeElement = typeof children.type === 'string';
  return /*#__PURE__*/React.cloneElement(children, {
    error: isNativeElement ? undefined : status === 'error',
    ...childrenProps
  });
};
function InternalFormItem(props) {
  const {
    children,
    ...formItemProps
  } = props;
  return /*#__PURE__*/_jsx(AntdFormItem, {
    ...formItemProps,
    children: /*#__PURE__*/React.isValidElement(children) ? /*#__PURE__*/_jsx(AddInputError, {
      ...children.props,
      children: children
    }) : children
  });
}
const FormItem = InternalFormItem;
FormItem.useStatus = AntdFormItem.useStatus;
export default FormItem;